import { clsx } from 'coreutils-js';
import { inject, observer } from "mobx-react";

import {
  Avatar, Button, InputSearch, Loading,
  Radio
  //@ts-ignore
} from '@microui/react-ui';

const InviteMember = ({ store }: any) => {
  const handleScroll = (e) => {
    if (store.loadingMember) return;

    const {
      scrollTop,
      scrollHeight,
      clientHeight
    } = e.target;

    if (scrollTop + clientHeight >= scrollHeight - 5 && store.accountData.length < store.accountTotal) {
      store.accountFilters.pageIndex += 1;
      store.getDataAccount();
    }
  }

  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex gap-3 w-full px-5 py-4">
        <InputSearch
          placeholder="Nhập từ khoá tìm kiếm: Họ và tên, Email..."
          className="flex-1"
          onChange={val => store.accountFilters.keyword = val}
          onSearch={() => store.getDataAccount(true)}
        />
        <Button
          color="primary"
          type="primary"
          onClick={() => store.getDataAccount(true)}
          loading={store.loadingMember}
        >
          Tìm kiếm
        </Button>
      </div>

      <div
        className="flex-1 flex flex-col gap-3 overflow-auto px-5 pb-4"
        onScroll={handleScroll}
      >
        {store.accountData.length == 0 && store.loadingMember && (
          <Loading size="large" />
        )}

        {store.accountData.length == 0 && !store.loadingMember && (
          <div className="w-full h-full text-button-2 font-medium text-gray-300 flex justify-center items-center">
            Hãy nhập từ khoá để tìm kiếm tài khoản.
          </div>
        )}

        {store.accountData.map(item => (
          <div
            key={item.id}
            className={clsx(
              'flex items-center justify-between rounded-[8px] border border-gray-700 bg-gray-800 px-[12px] py-[14px] cursor-pointer',
              store.selectedAccount?.id == item.id && 'border-primary'
            )}
            onClick={() => store.selectedAccount = item}
          >
            <Avatar
              value={item.avatar}
              data={{
                name: item.fullName,
                email: item.email
              }}
            />
            <Radio size="large" checked={store.selectedAccount?.id == item.id} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default inject('store')(observer(InviteMember));